<div class="card" style="">
  <div class="card-body">
    <h5 class="card-title">Abstract Summary Report Download</h5>
    <div class="description">
      Export a summary of the abstracts showing the coding progress (% QC coded, % reconciliation coded, % uncoded, etc.) with three tabs: all abstracts, abstracts by category and all abstracts broken down by mechanism with additional details.
    </div>
    <br />
    <button mat-button class="btn btn-success" (click)="onSubmit()">Run Report</button>
    <br />
  </div>
</div>
